module.exports = __webpack_public_path__ + "static/img/hall-blue.49a931e9.png";